import { render, staticRenderFns } from "./chart-area.vue?vue&type=template&id=4152b78c"
import script from "./chart-area.vue?vue&type=script&lang=js"
export * from "./chart-area.vue?vue&type=script&lang=js"
import style0 from "./chart-area.vue?vue&type=style&index=0&id=4152b78c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports